import { validateDiscount } from "../util/voucherHelper";
import { sortBy } from "lodash";
import { isObjectNotEmpty } from "../util/utils";
import { detectSpecial } from "./detectSpecial";
import { detectPersonalizedSpecial } from "./getVoucherDiscount";

export const getDiscount = (
  currentOrder,
  payableAmount,
  rowItems,
  specialDiscount,
  allSpecials,
  orderSetup,
  publicHolidays,
  storeConfig
) => {
  let matchingDiscounts = [];
  if (
    currentOrder.discountId &&
    currentOrder.discountId !== "" &&
    currentOrder.menuItems.length > 0
  ) {
    if (isObjectNotEmpty(currentOrder.selectedDiscount)) {
      let myDiscounts = currentOrder.selectedDiscount
        ? [currentOrder.selectedDiscount]
        : [];

      matchingDiscounts = myDiscounts.filter((v) => {
        return v._id === currentOrder.discountId;
      });

      if (matchingDiscounts && matchingDiscounts.length > 0) {
        let selectedDiscount = matchingDiscounts[0];

        if (
          validateDiscount(
            selectedDiscount,
            currentOrder,
            payableAmount,
            storeConfig
          ).success
        ) {
          let discountDiscountObj = getOrderDiscountedAmount(
            selectedDiscount,
            currentOrder,
            rowItems,
            specialDiscount,
            allSpecials,
            orderSetup,
            publicHolidays,
            storeConfig
          );
          if (discountDiscountObj.isDiscountValid) {
            if (
              selectedDiscount.type === "3" &&
              !selectedDiscount.isAvailableWithSpecials
            ) {
            } else {
              return {
                discountFound: true,
                discountDiscountObj: discountDiscountObj,
                selectedDiscount: selectedDiscount,
              };
            }
          } else {
            return {
              discountFound: false,
            };
          }
        } else {
          return {
            discountFound: false,
          };
        }
      } else {
        return {
          discountFound: false,
        };
      }
    } else {
      const discountInfo = {
        _id: currentOrder.discountId,
        discount: currentOrder.discount,
        discountName: currentOrder.discountName,
      };
      return {
        discountFound: true,
        discountDiscountObj: discountInfo,
        selectedDiscount: discountInfo,
      };
    }
  } else {
    return {
      discountFound: false,
    };
  }
};

export function getOrderDiscountedAmount(
  selectedDiscount,
  currentOrder,
  rowItems,
  specialDiscount,
  allSpecials,
  orderSetup,
  publicHolidays,
  storeConfig = {}
) {
  let resObj = {
    discount: 0,
    isDiscountValid: false,
    isItemOccupiedWithSpecials: false,
  };
  if (
    currentOrder &&
    selectedDiscount &&
    (selectedDiscount.type === "2" || selectedDiscount.type === "1")
  ) {
    resObj.isDiscountValid = true;
    if (selectedDiscount.discountType === "1") {
      resObj.discount = (
        (Number(currentOrder.payableAmount) *
          Number(selectedDiscount.discount)) /
        100
      ).toFixed(2);
      return resObj;
    } else {
      resObj.discount = selectedDiscount.discount;
      return resObj;
    }
  } else if (
    currentOrder &&
    selectedDiscount &&
    selectedDiscount.type === "3"
  ) {
    let discountWithoutFlag = detectPersonalizedSpecial(
      currentOrder,
      selectedDiscount,
      rowItems,
      false,
      storeConfig,
      orderSetup?.isSpecialsManuallyDisabled,
      orderSetup?.autoDetectSpecialsWeb
    );
    if (!selectedDiscount.isAvailableWithSpecials) {
      let discountFlag = detectPersonalizedSpecial(
        currentOrder,
        selectedDiscount,
        rowItems,
        true,
        storeConfig,
        orderSetup?.isSpecialsManuallyDisabled,
        orderSetup?.autoDetectSpecialsWeb
      );
      if (
        discountWithoutFlag.discountDiscount !== 0 &&
        discountFlag.discountDiscount === 0
      ) {
        rowItems = sortBy(
          rowItems.filter((f) => {
            return !discountWithoutFlag.usedIndexes.includes(f.primaryKey);
          }),
          "price"
        ).reverse();
        let specialObj = detectSpecial(
          currentOrder,
          rowItems,
          allSpecials,
          orderSetup,
          publicHolidays,
          storeConfig
        );

        let specials = specialObj.specials;
        //Calculate speical's discount
        let discount = 0;
        specials.map((s) => {
          discount = discount + Number(s.discount);
          return s;
        });
        if (
          Number(specialDiscount) - discount >
          discountWithoutFlag.discountDiscount
        ) {
          resObj.isItemOccupiedWithSpecials = false;
          resObj.isDiscountValid = false;
          resObj.discount = discountFlag.discountDiscount;
        } else {
          resObj.isItemOccupiedWithSpecials = true;
          resObj.isDiscountValid = true;
          resObj.specials = specials;
          resObj.discount = discountWithoutFlag.discountDiscount;
        }
      } else {
        resObj.discount = discountFlag.discountDiscount;
        resObj.isDiscountValid = true;
      }
    } else {
      resObj.isDiscountValid = true;
      resObj.discount = discountWithoutFlag.discountDiscount;
    }
    return resObj;
  } else return resObj;
}
